export const isLive = (duration: { from: Date; to: Date } | undefined) => {
  if (!duration) {
    return true;
  }

  const now = new Date();

  return now >= duration.from && now <= duration.to;
};
